import { APP_VERSION } from 'common/constants'

export const setCurrentVersion = () => {
  // eslint-disable-next-line no-underscore-dangle
  const currentVersion = window.__VERSION__

  if (currentVersion) {
    localStorage.setItem(APP_VERSION, currentVersion)
  }
}
